// extracted by mini-css-extract-plugin
module.exports = {"CallList__noCalls":"member-operations__CallList__CallList__noCalls","CallList__list":"member-operations__CallList__CallList__list"};